module.exports = __webpack_public_path__ + "img/aca_16_2.dd3861ac.png";